import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import Image from '@stories/Components/Misc/Image/Image';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.article `
  --accentColor: ${brand.primary.orange};
  --bgColor: ${brand.primary.blue};
  --fgColor: ${brand.white};

  background: var(--bgColor);
  border-radius: 10px;
  color: var(--fgColor);
  overflow: hidden;
`;
const Link = styled.a `
  position: relative;
  display: grid;
  aspect-ratio: 502 / 270;
  color: currentColor;
  text-decoration: none;
  border-radius: 10px;

  &:focus-visible {
    outline: auto;
    outline-offset: -5px;
    outline-width: 2px;
    outline-style: solid;
  }

  ${Container}[data-image="false"] & {
    grid-template-rows: 1fr 1fr;
  }
`;
const StyledImage = styled(Image) `
  ${transition('transform', 1)}

  position: absolute;
  inset: 0;
  display: block;
  transform: scale(1);
  width: 100%;
  z-index: 0;

  ${Link}:focus &,
  ${Link}:hover & {
    transform: scale(1.1);
  }
`;
const FallbackImage = styled.div `
  display: flex;
  place-content: center;
  place-items: center;

  svg {
    max-width: 90%;
  }
`;
const ContentWrapper = styled.div `
  position: relative;
  display: flex;
  align-items: flex-start;
  color: ${brand.white};
  flex-direction: column;
  justify-content: flex-end;
  padding: 24px;
  z-index: 1;

  ${Container}[data-image="true"] & {
    background: ${rgba(brand.black, 0.5)};
  }
`;
const Date = styled.time `
  position: absolute;
  top: 0;
  right: 24px;
  display: block;
  background: var(--accentColor);
  border-radius: 0px 0px 5px 5px;
  ${fonts.apparat.medium}
  font-size: 20px;
  line-height: 1em;
  padding: 8px 15px;
`;
const Tag = styled.span `
  display: block;
  background: var(--accentColor);
  border-radius: 5px;
  color: var(--fgColor);
  ${fonts.apparat.medium}
  font-size: 18px;
  line-height: 1em;
  margin-bottom: 24px;
  padding: 8px 15px;
`;
const Title = styled.span `
  display: block;
  ${fonts.apparat.medium}
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 16px;

  ${Link}:focus &,
  ${Link}:hover & {
    text-decoration: underline;
  }
`;
const FakeCta = styled.span `
  display: block;
  position: relative;
  display: inline-flex;
  align-items: center;
  ${fonts.apparat.semiBold}
  font-size: 18px;
  line-height: 1em;

  & > span {
    position: relative;
  }

  & > span::after {
    ${transition('transform')}

    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    background: var(--fgColor, ${brand.base.blue});
    height: 2px;
    transform: scaleX(0);
    transform-origin: center left;
    width: 100%;
  }

  svg {
    ${transition('transform')}

    display: block;
    color: var(--accentColor, ${brand.primary.orange});
    margin-left: 8px;
    width: 17px;
  }

  ${Link}:focus span&,
  ${Link}:hover span& {
    & > span::after {
      transform: scaleX(1);
    }

    svg {
      transform: translateX(16px);
    }
  }
`;
const NavigationCardStyles = {
    Container,
    ContentWrapper,
    Date,
    FakeCta,
    FallbackImage,
    Image: StyledImage,
    Link,
    Tag,
    Title,
};
export default NavigationCardStyles;
